import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import * as React from 'react';
import ChartLib from 'chart.js';
export var useCreateChart = function useCreateChart(chartCtx, chartConfig) {
  var _React$useState = React.useState(null),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    chart = _React$useState2[0],
    setChart = _React$useState2[1];
  React.useEffect(function () {
    if (chartCtx && chartConfig && !chart) {
      var _chart = new ChartLib(chartCtx, chartConfig);
      setChart(_chart);
    }
  }, [chartCtx, chartConfig, chart, setChart]);
  return chart;
};